import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { UIContext } from '../commonV3/context'

class MobileViewSliderV3 extends PureComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            modalList: new Map(),
            modalListKeys: [],
            currentIndex: 0,
            imageCount: 0,
            showTooltip: false,
            type: props.type || 'view360'
        };
    }

    componentDidMount() {
        this.updateStateFromProps();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.modalList !== this.props.modalList || prevProps.goToSlide !== this.props.goToSlide) {
            this.updateStateFromProps();
        }
    }

    updateStateFromProps = () => {
        if (this.props.modalList) {
            const listOfModal = [...this.props.modalList.keys()];
            let count = 0;
            listOfModal.forEach((hotSpotKey) => {
                if (this.props.modalList.get(hotSpotKey)?.closeUpURL) count++;
            });
            
            this.setState({
                modalList: this.props.modalList,
                modalListKeys: listOfModal,
                currentIndex: this.props.goToSlide || 0,
                imageCount: count
            });
        }
    }

    handlePrevious = () => {
        const newIndex = this.state.currentIndex > 0 
            ? this.state.currentIndex - 1 
            : this.state.modalListKeys.length - 1;
        
        this.setState({ currentIndex: newIndex });
        this.props.updateFocusPoint(newIndex);
    }

    handleNext = () => {
        const newIndex = this.state.currentIndex < this.state.modalListKeys.length - 1 
            ? this.state.currentIndex + 1 
            : 0;
        
        this.setState({ currentIndex: newIndex });
        this.props.updateFocusPoint(newIndex);
    }

    Capitalize = (sentence) => {
        if (!sentence) return '';
        try {
            let words = sentence.split(/[\s_]+/);
            let capitalizedWords = words.map(word => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            });
            return capitalizedWords.join(" ");
        } catch (error) {
            return sentence;
        }
    }

    handleTooltipToggle = () => {
        this.setState(prevState => ({
            showTooltip: !prevState.showTooltip
        }));
    }

    render() {
        const { modalListKeys, currentIndex, modalList, showTooltip } = this.state;
        const currentHotspotKey = modalListKeys[currentIndex];
        const currentHotspot = modalList.get(currentHotspotKey);
        
        if (!currentHotspot || !modalListKeys.length) {
            return null;
        }
        
        return (
            <UIContext.Consumer>
                {({ isEmbeddedContext }) => {
                    // Different positioning based on embedding context
                    const topPosition = isEmbeddedContext ? this.state.type === 'interior360' ? 'top-[6vh]' : 'top-[16vh]' : 'top-[38vh]';
                    const tooltipTopPosition = isEmbeddedContext ? 'top-[calc(16vh+32px)]' : 'top-[calc(38vh+32px)]';
                    
                    return (
                        <>
                            <div className={`absolute ${topPosition} w-[35%] left-2 bg-[#2C2C2C] rounded-lg z-[100] flex flex-col items-center gap-3 p-2 box-border shadow-[2px_0_10px_rgba(0,0,0,0.15)] `}>
                    {/* Close Button */}
                    <button 
                        onClick={this.props.hideModal}
                        className="absolute top-[-4px] right-[-4px] w-7 h-7 rounded-full bg-transparent border-none text-[#ffffff] flex items-center justify-center cursor-pointer transition-all duration-200 hover:bg-[#ffffff]/30"
                    >
                        <span className="text-base font-bold">×</span>
                    </button>
                    
                    {/* Header */}
                    <div className="flex w-[90%] h-[28px] items-center justify-between overflow-hidden">
                        <h2 className="text-[#ffffff] text-[10px] font-semibold m-0 flex-1 leading-tight overflow-hidden line-clamp-2">
                            {this.Capitalize(currentHotspot.heading) || 'Digital Rearview Mirror'}
                        </h2>
                        {/* <div className="w-5 h-5 rounded-full bg-[#ffffff] flex items-center justify-center ml-2 cursor-pointer">
                            <span className="text-[#2C2C2C] text-xs font-bold">i</span>
                        </div> */}
                    </div>
                    {/* Image Container */}
                    <div className="flex items-center justify-center relative">
                        <div className="w-[85px] h-[85px] rounded-full overflow-hidden bg-[#3A3A3A] flex items-center justify-center mx-auto">
                            {currentHotspot.closeUpURL ? (
                                <img 
                                    src={currentHotspot.closeUpURL} 
                                    alt={currentHotspot.heading || 'Hotspot'}
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="text-[#ffffff] text-sm text-center p-5">
                                    No Image Available
                                </div>
                            )}
                        </div>
                        
                        {/* Info Icon */}
                        <div className={`absolute top-0 right-0 w-3 h-3 rounded-full border flex items-center justify-center cursor-pointer transition-colors duration-200 ${
                            showTooltip 
                                ? 'border-white bg-[#ffffff]' 
                                : 'border-[#FFFFFF99] hover:bg-[#ffffff]/20'
                        }`} onClick={this.handleTooltipToggle}>
                            <span className={`text-[10px] font-bold ${
                                showTooltip 
                                    ? 'text-[#2C2C2C]' 
                                    : 'text-[#FFFFFF99]'
                            }`}>i</span>
                        </div>
                    </div>

                    {/* Navigation Container */}
                    <div className="flex items-center justify-between gap-2">
                        <button 
                            onClick={this.handlePrevious}
                            className="bg-transparent text-[#ffffff] flex items-center justify-center cursor-pointer transition-all duration-200 hover:bg-[#ffffff]/15 hover:scale-105 active:scale-95 disabled:opacity-30 disabled:cursor-not-allowed"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M15 18L9 12L15 6" stroke="#FFCD00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                        
                        <div className="text-[#ffffff] text-[10px] font-medium">
                            {currentIndex + 1} / {modalListKeys.length}
                        </div>
                        
                        <button 
                            onClick={this.handleNext}
                            className="bg-transparent text-[#ffffff] flex items-center justify-center cursor-pointer transition-all duration-200 hover:bg-[#ffffff]/15 hover:scale-105 active:scale-95 disabled:opacity-30 disabled:cursor-not-allowed"
                        >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M9 18L15 12L9 6" stroke="#FFCD00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>

                            {/* Tooltip - Positioned outside the main container */}
                            {showTooltip && (
                                <div className={`absolute left-[calc(2px+35%)] ${tooltipTopPosition} w-40 bg-[#ffffff] rounded-lg shadow-lg p-3 z-[200]`}>
                        {/* Arrow pointing to the 'i' icon */}
                        <div className="absolute left-[-6px] top-4 w-0 h-0 border-t-[6px] border-b-[6px] border-r-[6px] border-t-transparent border-b-transparent border-r-white"></div>
                        
                        <div className="flex justify-between items-start mb-2">
                            <h3 className="text-[#000000CC] text-left text-xs font-medium">{this.Capitalize(currentHotspot.heading) || 'No Heading Available'}</h3>
                            <button 
                                onClick={this.handleTooltipToggle}
                                className="text-black text-sm font-bold hover:text-gray-600"
                            >
                                ×
                            </button>
                        </div>
                        <p className="text-[#00000066] text-[10px] font-normal leading-relaxed text-left">
                            {currentHotspot?.desc || currentHotspot?.feature || 'No Description Available'}
                            </p>
                        </div>
                    )}
                        </>
                    );
                }}
            </UIContext.Consumer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        hotSpotMapObj: state.view360Reducer.hotSpotMapObj,
    }
}

export default connect(mapStateToProps, null)(MobileViewSliderV3);
